import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { StateServices } from '../../../../../services/state.services'
import { notification } from 'onsenui'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import * as moment from 'moment'
import { DatepickerHelper } from '../../../../../../helper/datepicker.helper'
import { SharedServices } from '../../../../../services/shared.services'
import { User } from '@models/user'
import { TimelineHelper } from '@helpers/timeline.helper'

@Component({
    selector: 'app-modal-form-timeline-top',
    templateUrl: './modal-form-timeline-top.component.html',
    styleUrls: [
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        './modal-form-timeline-top.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        '../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class ModalFormTimelineTopComponent implements OnInit, OnDestroy {

    emitDataFormTimeline: any
    isShowModal: any = 'hidden'
    arrayTags: any[] = []
    jsonDataSetting: any = {}
    jsonDataSave: any = {}
    jsonChangeDataSave: any = {}
    showEN = true
    en = {}
    isChange = false
    listOption2General: any[] = []
    idClient: any
    idAligner: any = undefined
    orSaveOrCreate: any = 'create'

    idUpdate: any

    arrayStaffCharge: any[] = []
    valueStaffCharge: any
    optionsStartDate: any = { viewMode: 'days', ...DatepickerHelper.BASE_OPTIONS }
    visitDate: any = ''

    view: 'user-timline'

    tabView: any = ''
    header = 'header'

    currentUser: User
    creator: string
    isEditNote: boolean = false

    constructor(
        private stateServices: StateServices,
        private authData: AuthService,
        private restApi: RestServices,
        private sharedServices: SharedServices,
    ) {
    }
    
    ngOnInit() {
        this.currentUser = this.authData.getUser()
        this.emitDataFormTimeline = this.stateServices.changeEmittedDataFormTimeline$.subscribe(res => {
            this.visitDate = moment(moment().valueOf())
            this.jsonDataSave['visitDate'] = undefined
            this.jsonDataSave['tags'] = []
            this.isChange = false
            const emitLoading = {}
            emitLoading['first'] = false
            this.stateServices.emitChangeFirstLoading(emitLoading)
            if (res && res['status']) {
                this.arrayStaffCharge = res['staff']
                this.isShowModal = res['status']
                this.arrayTags = res['tags']
                this.idClient = res['idClient']
                this.jsonDataSetting = res['data']
                this.orSaveOrCreate = res['action']
                this.tabView = res['view']
                if (res['action'] == 'create') {
                    this.jsonDataSave['tags'] = this.jsonDataSetting['tags']
                    this.isEditNote = true
                } else {
                    this.creator = res['jsonDataSave']['creator']
                    this.isEditNote = TimelineHelper.canCurrentUserEdit(this.currentUser, this.creator)
                    this.jsonDataSave = jQuery.extend(true, {}, res['jsonDataSave'])
                    this.idUpdate = this.jsonDataSave['_id']
                }
                this.listOption2General = jQuery.extend(
                    true,
                    [],
                    this.jsonDataSetting && this.jsonDataSetting['schema'] && this.jsonDataSetting['schema']['properties']
                        ? this.jsonDataSetting['schema']['properties']
                        : []
                )
                // this.jsonDataSave = {};
                this.jsonChangeDataSave = {}
            }
        })

        this.sharedServices.changeEmitted$.subscribe(success => {
            if (success && success == 'timeoutFormSetting') {
                this.isShowModal = 'hidden'
                const emitLoading = {}
                emitLoading['first'] = false
                this.stateServices.emitChangeFirstLoading(emitLoading)
                this.jsonDataSave = {}
                this.stateServices.emitChangeDataFormTimeline(null)
            }
        })
        this.getValueStaffCharge()
    }

    resetData() {
        this.listOption2General = []
        this.jsonDataSave = {}
        this.jsonDataSetting = {}
        this.jsonChangeDataSave = {}
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        if (keyPressed === 27) {
            event.preventDefault()
            if (this.isChange) {
                this.changeLanguage()
                notification.confirm({
                    message: this.en['alert-content-discard'],
                    title: '<b>' + this.en['alert-discard'] + '</b>',
                    cancelable: true,
                    buttonLabels: [this.en['alert-cancel'], 'OK'],
                    callback: i => {
                        if (i === 1) {
                            this.resetData()
                            const emitLoading = {}
                            emitLoading['first'] = false
                            this.stateServices.emitChangeFirstLoading(emitLoading)
                            this.stateServices.emitChangeDataFormTimeline(null)
                            this.isShowModal = 'hidden'
                        }
                    },
                })
            } else {
                this.resetData()
                const emitLoading = {}
                emitLoading['first'] = false
                this.stateServices.emitChangeFirstLoading(emitLoading)
                this.stateServices.emitChangeDataFormTimeline(null)
                this.isShowModal = 'hidden'
            }
        }
    }

    updateDatepicker(event, visitDate) {
        if (event && event['_d']) {
            const timestamp = moment(event['_d'])
            timestamp.set({ hours: 10 })
            this.jsonDataSave[visitDate] = moment(timestamp).utc().startOf('day').valueOf()
        }
    }

    getValueStaffCharge() {
        this.valueStaffCharge = this.stateServices.changeEmittedValueStaffCharge$.subscribe(res => {
            if (res && res['value']) {
                this.jsonDataSave['staff'] = res['value']['_id']
                this.jsonChangeDataSave['staff'] = res['value']['_id']
                this.isChange = true
                this.stateServices.emitChangeValueStaffCharge(null)
            }
        })
    }

    ngOnDestroy() {
        this.tabView = ''
        if(this.emitDataFormTimeline)
            this.emitDataFormTimeline.unsubscribe()
        if(this.valueStaffCharge)
            this.valueStaffCharge.unsubscribe()
        this.resetData()
    }


    getShowStaff(staff) {
        if (staff && staff != '') {
            const findStaff = this.arrayStaffCharge.find(el => {
                return el['_id'] == staff
            })
            let showName = ''
            if (findStaff) {
                if (findStaff['firstName']) {
                    showName += findStaff['firstName'] + ''
                }
                if (findStaff['familyName']) {
                    showName += findStaff['familyName']
                }
            }
            return showName
        }
    }

    getStaff(staff) {
        if (staff && staff != '') {
            const findStaff = this.arrayStaffCharge.find(el => {
                return el['_id'] == staff
            })
            if(findStaff) {
                return findStaff.deleted
            }
        }
    }

    optionModalSearchTimeline(staff) {
        const emitSearch: any = {}
        if (staff && staff != '') {
            emitSearch['selected'] = staff
        } else {
            emitSearch['selected'] = ''
        }
        emitSearch['action'] = 'active'
        emitSearch['data'] = this.arrayStaffCharge
        this.stateServices.emitChangeStaffCharge(emitSearch)
    }

    save() {
        this.jsonDataSave['type'] = 'form'
        this.jsonDataSave['clientId'] = this.idClient
        this.jsonDataSave['formParam'] = this.jsonDataSetting

        const { staffId } = this.currentUser
        if (staffId) {
            this.jsonDataSave['lastEditor'] = staffId
            if (this.orSaveOrCreate === 'create') {
                this.jsonDataSave['creator'] = staffId
            }
        }

        let sendAligner = {}
        if (this.orSaveOrCreate == 'create') {
            sendAligner = {
                collection: 'clientNote',
                id: null,
                type: 'create',
                value: this.jsonDataSave,
            }
        } else {
            const cannotEdit = !TimelineHelper.canCurrentUserEdit(this.currentUser, this.jsonDataSave['creator'])
            if (cannotEdit) {
                return
            }

            if (this.jsonDataSave.updateTime) {
                delete this.jsonDataSave.updateTime
            }
            if (this.jsonDataSave._id) {
                delete this.jsonDataSave._id
            }
            sendAligner = {
                collection: 'clientNote',
                id: this.idUpdate,
                type: 'update',
                value: this.jsonDataSave,
            }
        }
        const clientInfo = JSON.stringify({ clientId: this.idClient })
        const resourceData = {
            actions: [
                sendAligner,
            ],
            status: {
                client: {
                    map: { [this.idClient]: true },
                },
                clientAligner: {
                    paths: { [clientInfo]: true },
                },
                clientNote: {
                    paths: { [clientInfo]: true }, searches: { [clientInfo]: true },
                },
                // clientVisit: {

                // },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }

        if (this.authData.getItem('user')) {
            const user = JSON.parse(this.authData.getItem('user'));
            const expires = parseInt((user.expiresInSeconds)) * 1000;
            const timeOut = parseInt(this.authData.getItem('timeout')) + expires;
            const timeNow = Date.now();
            if(timeOut <= timeNow){
                this.isShowModal = 'hidden'
                this.stateServices.emitChangeDataFormTimeline(null)
            }
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.isShowModal = 'hidden'
                this.stateServices.emitChangeDataFormTimeline(null)
                const arrSearch: any[] = success['response']['clientNote']['searches'][clientInfo]
                const emitEditItem = {}
                emitEditItem['new'] = arrSearch
                this.stateServices.emitChangeUpdateAligner(emitEditItem)
            })
        })
    }

    onSave() {
        this.changeLanguage()
        if (this.isChange) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: this.en['alert-save'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {
                        this.save()
                    }
                },
            })
        } else {
            this.isShowModal = 'hidden'
            this.stateServices.emitChangeDataFormTimeline(null)
        }
    }

    functionEmitJsonSave(jsonSave: any) {
        this.jsonChangeDataSave = jsonSave
        this.isChange = true
        const listKeys: any[] = Object.keys(jsonSave)
        listKeys.forEach(key => {
            this.jsonDataSave[key] = this.jsonChangeDataSave[key]
        })
    }

    getDateToday(datetime = new Date()) {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        const today = new Date(datetime)
        const year = today.getFullYear()
        const month = ((today.getMonth() + 1) < 10) ? ('0' + (today.getMonth() + 1)) : (today.getMonth() + 1)
        const date = today.getDate() < 10 ? ('0' + today.getDate()) : today.getDate()
        return year + '.' + month + '.' + date + ' ' + days[today.getDay()]
    }

    getShowDate(dateStr) {
        let showDate
        if (dateStr) {
            showDate = this.getDateToday(dateStr)
        } else {
            this.jsonDataSave['visitDate'] = new Date().getTime()
            showDate = this.getDateToday(this.jsonDataSave['visitDate'])
        }
        return showDate
    }

    prevDate(visitDate, number) {
        if (this.jsonDataSave[visitDate]) {
            this.isChange = true
            const initDate = new Date(this.jsonDataSave[visitDate])
            const subDate = new Date(initDate.setDate(initDate.getDate() - number))
            this.jsonDataSave[visitDate] = subDate.getTime()
        }
    }

    nextDate(visitDate, number) {
        if (this.jsonDataSave[visitDate]) {
            this.isChange = true
            const initDate = new Date(this.jsonDataSave[visitDate])
            const subDate = new Date(initDate.setDate(initDate.getDate() + number))
            this.jsonDataSave[visitDate] = subDate.getTime()
        }
    }

    getClassTags(id) {
        const arraySaveTags: any[] = this.jsonDataSave['tags'] ? this.jsonDataSave['tags'] : []
        const findIndex = arraySaveTags.findIndex(el => {
            return el == id
        })
        if (findIndex != -1) {
            return true
        }
        return false
    }

    selectTag(id) {
        this.isChange = true
        const arraySaveTags: any[] = this.jsonDataSave['tags'] ? this.jsonDataSave['tags'] : []
        const findIndex = arraySaveTags.findIndex(el => {
            return el == id
        })
        if (findIndex == -1) {
            arraySaveTags.push(id)
        } else {
            arraySaveTags.splice(findIndex, 1)
        }
        this.jsonDataSave['tags'] = arraySaveTags
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    closeModal() {
        if (this.isChange) {
            this.changeLanguage()
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {
                        this.resetData()
                        this.isShowModal = 'hidden'
                        const emitLoading = {}
                        emitLoading['first'] = false
                        this.stateServices.emitChangeFirstLoading(emitLoading)
                        this.jsonDataSave = {}
                        this.stateServices.emitChangeDataFormTimeline(null)
                    }
                },
            })
        } else {
            this.isShowModal = 'hidden'
            const emitLoading = {}
            emitLoading['first'] = false
            this.stateServices.emitChangeFirstLoading(emitLoading)
            this.jsonDataSave = {}
            this.stateServices.emitChangeDataFormTimeline(null)
        }
    }

    removeFormData() {
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-discard'],
            title: this.en['alert-discard'],
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], 'OK'], callback: i => {
                if (i == 1) {
                    this.removeApi()
                }
            },
        })
    }

    removeApi() {
        const resourceUrl = 'resource'
        const map = {}
        map[this.idClient] = true
        const roomId = {}
        roomId['{"clientId":"' + this.idClient + '"}'] = true
        const resourceData = {
            actions: [
                {
                    collection: 'clientNote',
                    id: this.jsonDataSave['_id'],
                    type: 'remove',
                },
            ],
            status: {
                client: {
                    map,
                },
                clientNote: {
                    paths: roomId,
                    searches: roomId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        if (this.authData.getItem('user')) {
            const user = JSON.parse(this.authData.getItem('user'));
            const expires = parseInt((user.expiresInSeconds)) * 1000;
            const timeOut = parseInt(this.authData.getItem('timeout')) + expires;
            const timeNow = Date.now();
            if(timeOut <= timeNow){
                this.isChange = false
                this.closeModal()
            }
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    this.isChange = false
                    const emitDelete: any = {}
                    emitDelete['delete'] = true
                    this.stateServices.emitChangeDeleteTimeline(emitDelete)
                    this.closeModal()
                },
            )
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/timeline/modal-form-timeline-top/modal-form-timeline-top.component.ts